import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { mixpanel, links, string, compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Hero from './Hero/Hero'
import GiftInfo from './GiftInfo/GiftInfo'
import LastBlock from './LastBlock/LastBlock'
import SelectGender from './SelectGender/SelectGender'
import BrandsSection from './BrandsSection/BrandsSection'

import messages from './messages'


const giftSizes = [
  { size: 3,  save: '0',  price: '44' },
  { size: 6,  save: '6',  price: '84' },
  { size: 12, save: '15', price: '164' },
]


class GiftPage extends Component {

  static propTypes = {
    intl: PropTypes.object.isRequired, // @injectIntl
    isGiftFbPage: PropTypes.bool.isRequired,
  }

  componentDidMount() {
    const { isGiftFbPage } = this.props

    if (isGiftFbPage) {
      giftSizes.shift()
      mixpanel.track('Gift fb page')
    }
    else {
      mixpanel.track('Gift page')
    }

    actions.view.giftPage.setGiftSizes(giftSizes)
  }

  componentWillUnmount() {
    actions.view.giftPage.reset()
  }

  render() {
    const { intl, isGiftFbPage } = this.props

    const helmetProps = {
      title: intl.formatMessage(messages.pageTitle),
      meta: [
        {
          name: 'description',
          content: string.multiLineToOneLine(intl.formatMessage(messages.pageDescription)),
        },
      ],
    }

    return (
      <Fragment>
        <Helmet {...helmetProps} />
        <Hero />
        <GiftInfo />
        <SelectGender isGiftFbPage={isGiftFbPage} />
        <BrandsSection />
        <LastBlock />
      </Fragment>
    )
  }
}


export default compose(
  connect({
    isGiftFbPage: (state) => {
      const { routing: { location: { pathname } } } = state

      return pathname.includes(links.giftFb)
    },
  }),
  injectIntl,
)(GiftPage)
